import { useRef } from "react";
import { motion } from "framer-motion";

/** Subtle magnetic pull toward cursor (desktop). */
export default function MagneticButton({ children, className = "", strength = 0.22 }) {
  const ref = useRef(null);

  const move = (e) => {
    const el = ref.current;
    if (!el || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - (r.left + r.width / 2)) * strength;
    const y = (e.clientY - (r.top + r.height / 2)) * strength;
    el.style.setProperty("--mx", `${x}px`);
    el.style.setProperty("--my", `${y}px`);
  };

  const reset = () => {
    const el = ref.current;
    if (!el) return;
    el.style.setProperty("--mx", "0px");
    el.style.setProperty("--my", "0px");
  };

  return (
    <motion.span
      ref={ref}
      className={`magnetic-btn-wrap ${className}`.trim()}
      onMouseMove={move}
      onMouseLeave={reset}
      whileTap={{ scale: 0.98 }}
      transition={{ type: "spring", stiffness: 400, damping: 28 }}
    >
      <span className="magnetic-btn-inner">{children}</span>
    </motion.span>
  );
}
